<template>
  <div
    class="member-item medium-padding-bottom-z grid-x"
    :data-test-product-id="productId"
  >
    <ProductTitle
      :product-id="productId"
      :product-url="productUrl"
      class="show-for-small-only"
      :class="isSpacingExperimentEnabled ? 'margin-bottom-xs' : 'margin-bottom-m'"
      allow-opening-in-new-tab
    />
    <div
      :id="containerId"
      class="image-container cell medium-5 large-3"
    >
      <a
        :href="productUrl"
        class="product-link"
        target="_blank"
        aria-label="product link"
      >
        <Picture
          :image-url="primaryImage"
          :alt="`${productName} image`"
        />
      </a>
      <AddToList
        :container-id="containerId"
        :product-id="productId"
      />
    </div>
    <div class="order-panel cell medium-6 medium-offset-1 large-8">
      <div class="product-info">
        <ProductTitle
          tag="h3"
          :product-id="productId"
          :product-url="productUrl"
          class="hide-for-small-only"
          allow-opening-in-new-tab
        />
        <div
          v-if="productUrl"
          class="margin-top-m"
        >
          <a
            class="link-body"
            target="_blank"
            :href="productUrl"
          >
            View All Product Details
          </a>
        </div>
      </div>
    </div>
    <hr class="divider gray expanded small-margin-top-xl large-margin-top-xxl margin-bottom-z">
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Picture from '@common-vue/atomic-ui/src/components/picture';
import AddToList from '@components/AddToList';
import ProductTitle from '@components/ProductCard/ProductTitle.common';
import { useImages } from '@composables/useImages';
import { useExperiments } from '@composables/useExperiments';
import { useCommonProductGetters } from '@composables/useCommonProductGetters';

const props = defineProps({
  productId: {
    type: String,
    required: true,
  },
});

const { primaryImageData } = useImages();
// eslint-disable-next-line max-len
const { productUrl, productName } = useCommonProductGetters({ productId: props.productId });
const primaryImage = computed(() => primaryImageData.value.path);

const containerId = computed(() => `image-container-${props.productId}`);
const {
  experimentFlags: { isSpacingExperimentEnabled },
} = useExperiments();
</script>

<style lang="scss" scoped>
.order-panel {
  display: flex;
  flex-flow: column nowrap;
}
.image-container {
  position: relative;
}
.wishlist {
  position: absolute;
  top: 0;
  right: 14px;
  cursor: pointer;
}
.product-link {
  text-decoration: none;
}

@include breakpoint(large up) {
  .order-panel {
    flex-flow: row nowrap;
  }
  .member-item {
    flex-flow: row wrap;
  }
}
</style>
